import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardBody, FormGroup, Label, Input, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFormValues, change } from 'redux-form';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as currentUserActions from 'actions/currentUserActions';
import actionTypes from 'constants/currentUserConstants';

const emailValidator = value =>
  value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)

class EmailForm extends Component {
  static propTypes = {
    currentUser: ImmutablePropTypes.map.isRequired,
    submitForm: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    checkEmail: PropTypes.func.isRequired,
    formIsLoading: PropTypes.bool.isRequired,
  };

  state = {
    emailValid: true,
  };

  onEmailChange = (e) => {
    let email = e.target.value;
    if (email) email = email.toLowerCase();

    this.props.dispatch({ type: actionTypes.EMAIL_CHANGED });
    this.props.dispatch(change('eventSubmission', 'email', email));
  };

  onSubmit = (event) => {
    event.preventDefault();
    const { formValues: { email} } = this.props;
    const valid = emailValidator(email);
    this.setState({ emailValid: valid });
    if (!valid) return;
    this.props.checkEmail(email);
  };

  render() {
    const { formValues, currentUser, formIsLoading } = this.props;
    const isLoading = formIsLoading || currentUser.get('isLoading');

    return (
      <Card>
        <div className="card-header">
          <h4>Just one more thing...</h4>
        </div>
        <CardBody>
          <p>
            <strong>
              To complete submission and monitor your event's progress
              with our reporting, we need you to sign up or sign in.
            </strong>
          </p>
          <p>
            If you already have an account with evvnt, use the email you signed up with.
          </p>
          <p>
            If you are a new user, enter the email you want to sign up with.
          </p>
          <form onSubmit={this.onSubmit}>
            <fieldset>
              <FormGroup>
                <Label>Email *</Label>
                <Input
                  type="email"
                  placeholder="Your Email"
                  autoCapitalize="none"
                  autoCorrect="false"
                  value={formValues.email || ''}
                  onChange={this.onEmailChange}
                />
                {!this.state.emailValid && <p className="text-danger">Please enter a valid email address</p>}
              </FormGroup>
              <Button disabled={isLoading} block color="primary">
                {isLoading ? 'Please wait...' : 'Continue'}
              </Button>
            </fieldset>
          </form>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  formIsLoading: state.submissionForm.get('isLoading'),
  formValues: getFormValues('eventSubmission')(state),
  currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(currentUserActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/final/EmailForm.jsx